// extracted by mini-css-extract-plugin
var _1 = "SharingDropdownRow-module__animateUploadProgressBarWidth--enTU1";
var _2 = "SharingDropdownRow-module__animatedBackground--ptiFB";
var _3 = "SharingDropdownRow-module__info--dN3Wd";
var _4 = "SharingDropdownRow-module__main--ddAgV";
var _5 = "SharingDropdownRow-module__role--ISchs";
var _6 = "SharingDropdownRow-module__row--qtw3e";
var _7 = "SharingDropdownRow-module__secondary--lWgwC";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "info", _4 as "main", _5 as "role", _6 as "row", _7 as "secondary" }
